module.exports = __webpack_public_path__ + "img/corporate-risk.de5c2644.png";